module.exports = __webpack_public_path__ + "static/media/tokiwa10-6.e9c4de45.jpg";